Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRawData = setRawData;
exports.setLoading = setLoading;
exports.setError = setError;
exports.setTimestamp = setTimestamp;
exports.setSearchId = setSearchId;
exports.setSuggestionsSearchId = setSuggestionsSearchId;
exports.setQuery = setQuery;
exports.setCustomQuery = setCustomQuery;
exports.setDefaultQuery = setDefaultQuery;
exports.setCustomHighlightOptions = setCustomHighlightOptions;
exports.updateQueryOptions = updateQueryOptions;
exports.logQuery = logQuery;
exports.logCombinedQuery = logCombinedQuery;
exports.setHeaders = setHeaders;
exports.setPromotedResults = setPromotedResults;
exports.setPopularSuggestions = setPopularSuggestions;
exports.setDefaultPopularSuggestions = setDefaultPopularSuggestions;
exports.setCustomData = setCustomData;
exports.setAppliedSettings = setAppliedSettings;
exports.setQueryListener = setQueryListener;

var _constants = require('../constants');

function setRawData(component, response) {
  return {
    type: _constants.SET_RAW_DATA,
    component: component,
    response: response
  };
}

function setLoading(component, isLoading) {
  return {
    type: _constants.SET_LOADING,
    component: component,
    isLoading: isLoading
  };
}

function setError(component, error) {
  return {
    type: _constants.SET_ERROR,
    component: component,
    error: error
  };
}

function setTimestamp(component, timestamp) {
  return {
    type: _constants.SET_TIMESTAMP,
    component: component,
    timestamp: timestamp
  };
}

function setSearchId() {
  var searchId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: _constants.SET_SEARCH_ID,
    searchId: searchId
  };
}

function setSuggestionsSearchId() {
  var searchId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: _constants.SET_SUGGESTIONS_SEARCH_ID,
    searchId: searchId
  };
}

function setQuery(component, query) {
  return {
    type: _constants.SET_QUERY,
    component: component,
    query: query
  };
}

function setCustomQuery(component, query) {
  return {
    type: _constants.SET_CUSTOM_QUERY,
    component: component,
    query: query
  };
}

function setDefaultQuery(component, query) {
  return {
    type: _constants.SET_DEFAULT_QUERY,
    component: component,
    query: query
  };
}

function setCustomHighlightOptions(component, data) {
  return {
    type: _constants.SET_CUSTOM_HIGHLIGHT_OPTIONS,
    component: component,
    data: data
  };
}

function updateQueryOptions(component, options) {
  return {
    type: _constants.SET_QUERY_OPTIONS,
    component: component,
    options: options
  };
}

function logQuery(component, query) {
  return {
    type: _constants.LOG_QUERY,
    component: component,
    query: query
  };
}

function logCombinedQuery(component, query) {
  return {
    type: _constants.LOG_COMBINED_QUERY,
    component: component,
    query: query
  };
}

function setHeaders(headers) {
  return {
    type: _constants.SET_HEADERS,
    headers: headers
  };
}

function setPromotedResults() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var component = arguments[1];
  return {
    type: _constants.SET_PROMOTED_RESULTS,
    results: results,
    component: component
  };
}

function setPopularSuggestions() {
  var suggestions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var component = arguments[1];
  return {
    type: _constants.SET_POPULAR_SUGGESTIONS,
    suggestions: suggestions,
    component: component
  };
}

function setDefaultPopularSuggestions() {
  var suggestions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var component = arguments[1];
  return {
    type: _constants.SET_DEFAULT_POPULAR_SUGGESTIONS,
    suggestions: suggestions,
    component: component
  };
}

function setCustomData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var component = arguments[1];
  return {
    type: _constants.SET_CUSTOM_DATA,
    data: data,
    component: component
  };
}

function setAppliedSettings() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var component = arguments[1];
  return {
    type: _constants.SET_APPLIED_SETTINGS,
    data: data,
    component: component
  };
}

function setQueryListener(component, onQueryChange, onError) {
  return {
    type: _constants.SET_QUERY_LISTENER,
    component: component,
    onQueryChange: onQueryChange,
    onError: onError
  };
}